import { CATEGORY_COLORS } from "@/types";

/**
 * Get the signal color class for an activity percentage.
 * ≥70% → high (green), 40–69% → mid (amber), <40% → low (red), null/0 → idle
 */
export function getActivityColor(percent: number | null | undefined): string {
  if (percent == null || percent === 0) return "var(--color-signal-idle)";
  if (percent >= 70) return "var(--color-signal-high)";
  if (percent >= 40) return "var(--color-signal-mid)";
  return "var(--color-signal-low)";
}

/**
 * Get the CSS class name for activity badge.
 */
export function getActivityBadgeClass(
  percent: number | null | undefined,
): string {
  if (percent == null || percent === 0) return "activity-badge-idle";
  if (percent >= 70) return "activity-badge-high";
  if (percent >= 40) return "activity-badge-mid";
  return "activity-badge-low";
}

/**
 * Get the category color for a given category name.
 */
export function getCategoryColor(category: string): string {
  return CATEGORY_COLORS[category] || CATEGORY_COLORS.Other;
}

/**
 * Format duration in minutes to readable string.
 */
export function formatMinutes(minutes: number): string {
  if (minutes < 1) return "<1m";
  if (minutes < 60) return `${Math.round(minutes)}m`;
  const hours = Math.floor(minutes / 60);
  const mins = Math.round(minutes % 60);
  return mins > 0 ? `${hours}h ${mins}m` : `${hours}h`;
}

/**
 * Get status color for user avatar ring.
 */
export function getStatusColor(
  isCheckedIn: boolean,
  isCurrentlyPaused: boolean,
): string {
  if (!isCheckedIn) return "var(--color-status-offline)";
  if (isCurrentlyPaused) return "var(--color-status-paused)";
  return "var(--color-status-online)";
}

/**
 * Get initials from a full name.
 */
export function getInitials(name: string): string {
  return name
    .split(" ")
    .map((n) => n[0])
    .filter(Boolean)
    .slice(0, 2)
    .join("")
    .toUpperCase();
}
